import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import t from 'react-translate';

import { config } from '@config/pendo.config.json';
import ManageUsageModal from './manage-usage-modal';
import cardTextStyles from './ai-hub-styles';

const RoleplayUsageManagementCard = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div
      css={cardTextStyles}
      className='d-flex align-items-center justify-content-between'
    >
      <div className='mr-4'>
        <div className='card-text font-weight-bold'>
          {t.INSTITUTIONS.ADVANCED_SETTINGS.GENERATIVE_AI_CAPABILITIES.ROLEPLAY_USAGE_MANAGEMENT.TITLE()}
        </div>
        <div className='card-text'>
          {t.INSTITUTIONS.ADVANCED_SETTINGS.GENERATIVE_AI_CAPABILITIES.ROLEPLAY_USAGE_MANAGEMENT.CARD_DESCRIPTION()}
        </div>
      </div>
      <Button
        variant='secondary'
        className='flex-shrink-0'
        onClick={() => setShowModal(true)}
        data-qa={config.pendo.activities.aiRolePlay.usageManagement.manageButton}
      >
        {t.INSTITUTIONS.ADVANCED_SETTINGS.GENERATIVE_AI_CAPABILITIES.ROLEPLAY_USAGE_MANAGEMENT.MANAGE_USAGE()}
      </Button>
      <ManageUsageModal show={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
};

export default RoleplayUsageManagementCard;
